import React, { useRef, useEffect } from 'react'
import { IProps } from './index'
import { Text } from '../../../../library/elements/Text'
import edgeTexture from '../../../../library/images/edge-texture.svg'
import { LegacyColor, mq, containerMaxWidth, TIMING } from '../../../../library/utils'
import queryString from 'query-string'
import { Image } from 'marketing-site/src/library/elements/Image'
import { CTAButton } from 'marketing-site/src/library/elements/CTAButton'
import { CTATheme } from 'marketing-site/src/library/utils'
import { ProductToursDemo as ProductToursDemoDefault } from './component'
import { useBrand, BrandOptions } from 'marketing-site/src/library/providers/brandProvider'
import tools from './launchProductTourDemo'

export const ProductToursDemo = (props: IProps) => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <ProductToursDemoDefault {...props} />
  }
  return <ProductToursDemoLegacy {...props} />
}

function ProductToursDemoLegacy({ heading, buttonLabel }: IProps) {
  const productToursComponent = useRef<HTMLDivElement>(null)

  function scrollToProductTourDemo() {
    const header = document.getElementById('site-header')
    if (header) {
      if (!productToursComponent.current) return
      const headerHeight = header.clientHeight
      const productToursComponentRect = productToursComponent.current.getBoundingClientRect()
      window.scroll({
        top: productToursComponentRect.top + window.scrollY - headerHeight,
        left: 0,
        behavior: 'smooth',
      })
    }
  }

  useEffect(() => {
    const queryParams = queryString.parse(window.location.search)
    setTimeout(function () {
      if (queryParams['product_tour_id'] && productToursComponent.current) {
        scrollToProductTourDemo()
      }
    }, 1000)
  })

  return (
    <div className="product-tours-demo-spotlight" ref={productToursComponent} aria-hidden>
      <div className="content">
        <p className="heading">
          <Text size={'xxl+'}>{heading}</Text>
        </p>

        <div className="cta">
          <CTAButton
            onClick={tools.launchProductTourDemo(scrollToProductTourDemo)}
            bgColor={CTATheme.BlackFill}
            text={buttonLabel}
          />
        </div>

        <div className="demo-image-wrapper">
          <Image url="https://images.ctfassets.net/xny2w179f4ki/56MrDVyPi6oii653L9Zpnh/380abe0de332fbe45c950573b65dfba4/0088_ProductTours-FakeProduct-ProactiveSupport-LB_5x3_0521_2x.png" />

          <div className="demo-spot demo-spot-1" data-product-tours-demo-spot="1" />
          <div className="demo-spot demo-spot-2" data-product-tours-demo-spot="2" />
          <div className="demo-spot demo-spot-3" data-product-tours-demo-spot="3" />
        </div>
      </div>

      <style jsx>
        {`
          .product-tours-demo-spotlight {
            display: none;
          }

          @media (${mq.tablet}) {
            .product-tours-demo-spotlight {
              display: grid;
              grid-template-columns: 1fr [content] 2fr 1fr;
              background-color: ${LegacyColor.LightBlue};
              padding: 80px 0;
              position: relative;
            }

            .content {
              grid-column: content;
              display: grid;
              grid-template-rows: repeat(3, auto);
              text-align: center;
              margin: 0 auto 80px;
              max-width: ${containerMaxWidth};
            }

            .product-tours-demo-spotlight:after {
              content: '';
              position: absolute;
              background-color: inherit;
              height: 18px;
              left: -3vw;
              mask-image: url(${edgeTexture});
              mask-repeat: repeat no-repeat;
              width: 106vw;
              z-index: -1;
            }

            .product-tours-demo-spotlight:after {
              bottom: -17px;
            }

            .cta {
              margin: 36px;
            }

            .arrow {
              margin-left: 6px;
              height: 10px;
              fill: ${LegacyColor.White};
              transition: all ${TIMING.FAST}ms;
            }

            .demo-image-wrapper {
              grid-column: '1 / -1';
              padding: '0 12vw';
              max-height: 600px;
              width: 768px;
              margin: 0 auto;
              position: relative;
            }

            .demo-image {
              max-width: 100%;
            }

            .demo-spot {
              position: absolute;
            }

            .demo-spot-1 {
              top: 142px;
              left: 15px;
              width: 46px;
              height: 38px;
            }

            .demo-spot-2 {
              top: 104px;
              left: 82px;
              width: 70px;
              height: 132px;
            }

            .demo-spot-3 {
              top: 17px;
              left: 686px;
              width: 55px;
              height: 28px;
            }
          }

          @media (${mq.desktop}) {
            .demo-image-wrapper {
              width: 1016px;
            }

            .demo-spot-1 {
              top: 190px;
              left: 19px;
              width: 62px;
              height: 46px;
            }

            .demo-spot-2 {
              top: 140px;
              left: 110px;
              width: 90px;
              height: 172px;
            }

            .demo-spot-3 {
              top: 24px;
              left: 909px;
              width: 70px;
              height: 34px;
            }
          }
        `}
      </style>
    </div>
  )
}
